import * as actionTypes from  '../actions/actionTypes';
import { updateObject } from '../../utils/updateObject';

const INITIAL_STATE = {
    name: null,
    loading: false,
    superadmin: false,
    email: '',
    access: [],
    authRedirectPath: '/',
    selectedAccess: {},
    photo: null,
    receiveAutomaticEmails: true,
    id: '',
}

const authStart = (state) => {
    return updateObject(state, {error: null, loading: true})
}

const authSuccess = (state, action) => {

    return updateObject(state, {
        id: action.id,
        name: action.name,
        selectedAccess: action.selectedAccess, 
        access: action.access,
        superadmin: action.superadmin,
        email: action.email,
        error: null,
        loading: false,
        photo: action.photo,
    })
}

const authFail = (state, action) => {
    return updateObject(state, {
        error: action.error,
        loading: false
    })
}

const selectTenant = (state, action) => {
    return updateObject(state, {
        selectedAccess: action.tenant, 
        loading: false
    })
}

const setAuthRedirectPath = (state, action) => {
    return updateObject(state, {authRedirectPath: action.path})
}

const authChangeNameSuccess = (state, action) => {
    return updateObject(state, { loading: false, name: action.name });
}

const authChangeProfilePictureSuccess = (state, action) => {
  return updateObject(state, { loading: false, photo: action.photo });
}

const authChangeReceiveAutomaticEmailsSuccess = (state, action) => {
  const selectedAccess = state.selectedAccess;
  const access = [...state.access];
  const accessIndex = access.findIndex(ac => ac.tenant._id === action.selectedTenant);
  selectedAccess.receiveAutomaticEmails = action.receiveAutomaticEmails;
  access[accessIndex].receiveAutomaticEmails = action.receiveAutomaticEmails;
  return updateObject(state, { loading: false, access, selectedAccess });
}

const authChangePasswordSuccess = (state, action) => {
  return updateObject(state, { loading: false });
}

const authChangeShowServiceReportCoordinates = (state, action) => {
  const selectedAccess = state.selectedAccess;
  const access = [...state.access];
  const accessIndex = access.findIndex(ac => ac.tenant._id === action.selectedTenant);
  selectedAccess.showServiceReportCoordinates = action.showServiceReportCoordinates;
  access[accessIndex].showServiceReportCoordinates = action.showServiceReportCoordinates;
  return updateObject(state, { loading: false, access, selectedAccess });
}

const reducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.AUTH_START: return authStart(state);
        case actionTypes.AUTH_SUCCESS: return authSuccess(state, action);
        case actionTypes.AUTH_FAIL: return authFail(state, action);
        case actionTypes.AUTH_SELECT_TENANT: return selectTenant(state, action);
        case actionTypes.AUTH_CHANGE_NAME_SUCCESS: return authChangeNameSuccess(state, action);
        case actionTypes.AUTH_CHANGE_PROFILE_PICTURE_SUCCESS: return authChangeProfilePictureSuccess(state, action);
        case actionTypes.AUTH_CHANGE_PASSWORD_SUCCESS: return authChangePasswordSuccess(state, action);
        case actionTypes.AUTH_CHANGE_RECEIVE_AUTOMATIC_EMAILS_SUCCESS: return authChangeReceiveAutomaticEmailsSuccess(state, action);
        case actionTypes.AUTH_CHANGE_SHOW_SERVICE_REPORT_COORDINATES_SUCCESS: return authChangeShowServiceReportCoordinates(state, action);
        case actionTypes.SET_AUTH_REDIRECT_PATH: return setAuthRedirectPath(state, action);
        default:
            return state
    }
}

export default reducer